import React, { Fragment, useEffect, useMemo, useState } from "react";
import MessageItem from "../../Sav/NewTicketSav/ChatContainer/MessageItem";
import { useDispatch, useSelector } from "react-redux";
import {
  createResellerComment,
  getResellerComments,
} from "../../../REDUX/actions/reseller";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { isDefined } from "../../../Utils";
import RichTextEditor from "../../RichTextEditor";

const Comments = ({ scrollableComment, setScrollableComment }) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const {
    currentReseller,
    currentComments,
    currentCommentsLoading: loading,
  } = useSelector((state) => state.resellerReducer);
  const { user } = useSelector((state) => state.userReducer);
  const [newMessage, setNewMessage] = useState({ text: "", attachments: [] });
  const [isEditing, setIsEditing] = useState(false);

  const groupMessagesByDate = (messages) => {
    return messages?.reduce((acc, message) => {
      const createdAt = message?.attributes?.createdAt;
      const formattedDate = createdAt ? moment(createdAt).format("LL") : "-"; // Example: January 31, 2025

      if (!acc[formattedDate]) {
        acc[formattedDate] = [];
      }
      acc[formattedDate].push(message);

      return acc;
    }, {});
  };

  const groupedMessages = useMemo(
    () => groupMessagesByDate(currentComments),
    [currentComments]
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "attachments") {
      setNewMessage({
        ...newMessage,
        [name]:
          newMessage?.attachments?.length > 0
            ? [...newMessage?.attachments, ...value]
            : value,
      });
    } else {
      setNewMessage({ ...newMessage, [name]: value });
    }
  };

  const handleSubmit = (e, callback) => {
    e.preventDefault();
    if (
      newMessage?.text?.trim()?.length > 0 ||
      newMessage?.attachments?.length > 0
    ) {
      dispatch(
        createResellerComment(
          newMessage,
          currentReseller?.id,
          user?.id,
          () => {
            setNewMessage({ text: "", attachments: [] });
            callback();
          },
          t
        )
      );
    }
  };

  useEffect(() => {
    if (currentReseller?.id) {
      dispatch(getResellerComments(currentReseller?.id));
    }
  }, [dispatch, currentReseller?.id]);

  useEffect(() => {
    if (isDefined(scrollableComment) && currentComments?.length > 0) {
      document
        .getElementById(scrollableComment)
        ?.scrollIntoView({ behavior: "smooth" });
      setScrollableComment();
    }
  }, [scrollableComment, currentComments, setScrollableComment]);

  return (
    <div className="ps-5 pe-3 py-4 store newSavComment d-flex flex-column justify-content-end max-w-600px w-100 mx-auto">
      <div className="d-flex pe-4 flex-column overflow-auto flex-column-reverse pt-4 pb-5">
        {Object.entries(groupedMessages).map(([date, messages]) => (
          <Fragment key={date}>
            {messages.map((comment, index) => (
              <MessageItem
                key={comment?.id}
                index={index}
                message={comment}
                isOwner={+user?.id === +comment?.attributes?.user?.data?.id}
                view="RESELLER"
                position={index === 0 ? "bottom" : "top"}
                isEditing={isEditing}
                setIsEditing={setIsEditing}
              />
            ))}
            <div className="text-center text-muted my-2 px-4 py-2 f11 bg-dimGrey br5 sBold d-flex fit-content mx-auto text-dark">
              {date}
            </div>
          </Fragment>
        ))}
      </div>
      <div className={"pe-4"}>
        <RichTextEditor
          handleChange={handleChange}
          newMessage={newMessage}
          loading={loading}
          setNewMessage={setNewMessage}
          handleSubmit={handleSubmit}
        />
      </div>
    </div>
  );
};

export default Comments;
